import React from 'react';
import { TypedMemo } from '../../../../common/types';
import { withBrandWord } from '../../../components/primitives/BrandWord';
/* eslint-disable css-modules/no-unused-class -- one stylesheet for the Studio; each part uses its own slice of it */
import styles from '../Studio.module.scss';
/* eslint-enable css-modules/no-unused-class */

interface DetailFieldProps {
  title: string;
  hint?: string;
  children: React.ReactNode;
}

/** One field of step 3 (designs n1–n3): a head with the title and the hint, then the control. */
const DetailFieldComponent: React.FC<DetailFieldProps> = ({ title, hint, children }) => (
  <section className={styles.field}>
    <div className={styles.fieldHead}>
      <h3 className={styles.fieldTitle}>{title}</h3>
      {hint !== undefined && <span className={styles.hint}>{withBrandWord(hint)}</span>}
    </div>
    {children}
  </section>
);

export const DetailField = TypedMemo(DetailFieldComponent);
